import { render, staticRenderFns } from "./CorporateActivityDashboard.vue?vue&type=template&id=97f9434e"
import script from "./CorporateActivityDashboard.vue?vue&type=script&lang=js"
export * from "./CorporateActivityDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports